import { CookiesView } from '@shared/components/Cookies/index';
import { useCookie } from '@shared/contexts/cookie-context';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Cookies: React.FC = () => {
  const { t } = useTranslation();
  const { showBanner, onClickAccept, onClickDecline } = useCookie();

  if (!showBanner) {
    return null;
  }

  return (
    <CookiesView
      title={t('cookiesContent.cookiesTitle')}
      description={[
        t('cookiesContent.cookiesDescriptionOne'),
        t('cookiesContent.cookiesDescriptionTwo'),
        t('cookiesContent.cookiesDescriptionThree'),
      ]}
      acceptButtonText={t('cookiesContent.cookiesAcceptBtnText')}
      declineButtonText={t('cookiesContent.cookiesDeclineBtnText')}
      onClickAccept={onClickAccept}
      onClickDecline={onClickDecline}
    />
  );
};
